import React from 'react';

import { StyledClientsApiPage } from './ClientsApiPage.style';
import appLogo from '../../ui/assets/images/app-icon.svg';
import { useAppDispatch, useAppSelector } from '../../store/store';
import addressSliceThunks from '../../store/addressSlice/addressSlice.thunks';

const ClientApiPage: React.FC = () => {
  const [apiKey, setApiKey] = React.useState<string>('');
  const [postcode, setPostcode] = React.useState<string>('');
  const [text, setText] = React.useState<string>('');
  const [textOrPostcode, setTextOrPostcode] = React.useState<string>('');

  const dispatch = useAppDispatch();
  const adressData = useAppSelector(({ addressState }) => addressState.addresses);
  const jsonData = JSON.stringify(adressData, null, 2);

  const searchByPostalCode = () => {
    setText('');
    setTextOrPostcode('');
    dispatch(addressSliceThunks.getAddressesByPostcode({ postcode, apiKey }));
  };

  const searchByText = () => {
    setPostcode('');
    setTextOrPostcode('');
    dispatch(addressSliceThunks.getAddressesByText({ text, apiKey }));
  };

  const searchByTextOrPostcode = () => {
    setPostcode('');
    setText('');
    dispatch(addressSliceThunks.getAddressesByTextOrPostcode({ text: textOrPostcode, apiKey }));
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(jsonData);
  };

  return (
    <StyledClientsApiPage>
      <img src={appLogo} alt="Logo" className="clients-page__logo" />
      <div className="clients-page__title">Data searching page</div>
      <label className="clients-page__label">Api key</label>
      <input
        value={apiKey}
        onChange={(e) => setApiKey(e.target.value)}
        className="clients-page__input"
        placeholder="Paste here your api key ..."
      />
      <label className="clients-page__label">Postal code search</label>
      <div className="clients-page__input-wrapper">
        <input
          value={postcode}
          onChange={(e) => setPostcode(e.target.value)}
          className="clients-page__input"
          placeholder="Enter postal code here ..."
        />
        <button onClick={searchByPostalCode} className="clients-page__button">Search</button>
      </div>
      <label className="clients-page__label">Address search</label>
      <div className="clients-page__input-wrapper">
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="clients-page__input"
          placeholder="Enter search text here ..."
        />
        <button onClick={searchByText} className="clients-page__button">Search</button>
      </div>
      <label className="clients-page__label">Search by postcode or text</label>
      <div className="clients-page__input-wrapper">
        <input
          value={textOrPostcode}
          onChange={(e) => setTextOrPostcode(e.target.value)}
          className="clients-page__input"
          placeholder="Enter search text here ..."
        />
        <button onClick={searchByTextOrPostcode} className="clients-page__button">Search</button>
      </div>
      <div className="clients-page__data-wrapper">
        <pre className="clients-page__data">
          {jsonData}
        </pre>
        <button
          onClick={handleCopy}
          className="clients-page__button"
        >
          Copy to clipboard
        </button>
      </div>
    </StyledClientsApiPage>
  );
};

export default ClientApiPage;
